<template>
  <div class="app-container">
    <div class="filter-container">
      <el-row>
        <el-col :span="2">
          <div class="grid-content bg-purple">
            <el-button
              class="filter-item"
              type="primary"
              icon="el-icon-edit"
              @click="handleCreate"
            >新增</el-button>
          </div>
        </el-col>
        <el-col :span="22">
          <div class="grid-content bg-purple-light">
            <el-form :inline="true" :model="listQuery" class="demo-form-inline">
              <el-form-item label>
                <el-input v-model="listQuery.keyword" placeholder="商品名称" :clearable="true"></el-input>
              </el-form-item>
              <el-form-item label>
                <el-select placeholder="套餐" v-model="listQuery.type" :clearable="true">
                  <el-option label="套餐" :value="1"></el-option>
                  <el-option label="路线" :value="2"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label>
                <el-select placeholder="审核状态" v-model="listQuery.inspect_status" :clearable="true">
                  <el-option label="未审核" value="0"></el-option>
                  <el-option label="通过" value="1"></el-option>
                  <el-option label="驳回" value="2"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="onSubmit">搜索</el-button>
              </el-form-item>
            </el-form>
          </div>
        </el-col>
      </el-row>
    </div>

    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      border
      fit
      highlight-current-row
    >
      <el-table-column align="center" label="序号" width="95">
        <template slot-scope="scope">
          {{ scope.$index+1 }}
          <!-- {{ scope.row.id }} -->
        </template>
      </el-table-column>
      <el-table-column label="商品id" min-width="110" align="center">
        <template slot-scope="scope">
          {{
          scope.row.id
          }}
        </template>
      </el-table-column>
      <el-table-column label="套餐标题" min-width="110" align="center">
        <template slot-scope="scope">{{ scope.row.title }}</template>
      </el-table-column>
      <el-table-column label="商品图片" min-width="110" align="center">
        <template slot-scope="scope">
          <img :src="scope.row.cover" class="user-avatar" />
        </template>
      </el-table-column>
      <el-table-column label="参考价格" min-width="110" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.currency_type == 2">A${{ scope.row.price }}</span>
          <span v-else>￥{{ scope.row.price }}</span>
        </template>
      </el-table-column>
      <el-table-column label="已售" min-width="110" align="center">
        <template slot-scope="scope">{{ scope.row.sell }}</template>
      </el-table-column>
      <el-table-column label="库存" min-width="110" align="center">
        <template slot-scope="scope">{{ scope.row.stock }}</template>
      </el-table-column>
      <el-table-column label="类型" min-width="110" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.type == 2">路线</span>
          <span v-else>套餐</span>
        </template>
      </el-table-column>
      <el-table-column class-name="status-col" label="审核状态" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.inspect_status == 1" type="success">通过</el-tag>
          <el-tag v-if="scope.row.inspect_status == 0" type="warning">未审核</el-tag>
          <el-tooltip placement="top">
            <div slot="content">驳回原因:{{ scope.row.refuse_reason }}</div>
            <el-tag v-if="scope.row.inspect_status == 2" type="danger">驳回</el-tag>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column class-name="status-col" label="状态" min-width="110" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.status == 0" style="color:red;">已下架</span>
          <span v-else>正常</span>
        </template>
      </el-table-column>

      <el-table-column label="操作" align="left" width="230" class-name="small-padding fixed-width">
        <template slot-scope="scope">
          <el-row>
            <el-button type="primary" size="mini" @click="handleShowInfo(scope.row)">查看详情</el-button>
            <el-button type="warning" size="mini" @click="handleUpdate(scope.row.id)">修改</el-button>
          </el-row>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog title="详情" v-if="showInfo" :visible.sync="showInfo">
      <el-form ref="form" :model="info" label-width="120px">
        <!-- <el-form-item label="序号">
          <div>{{ info.id }}</div>
        </el-form-item>-->
        <el-form-item label="商品id">
          <div>{{ info.id }}</div>
        </el-form-item>
        <el-form-item label="套餐标题">
          <div>{{ info.title }}</div>
        </el-form-item>
        <el-form-item label="商品图片">
          <div>
            <img v-if="info.cover != ''" :src="info.cover" alt style="width: 150px;" />
          </div>
        </el-form-item>
        <el-form-item label="参考价格">
          <div v-if="info.currency_type == 2">A${{ info.price }}</div>
          <div v-else>{{ info.price }}</div>
        </el-form-item>
        <el-form-item label="已售">
          <div>{{ info.sell }}</div>
        </el-form-item>
        <el-form-item label="库存">
          <div>{{ info.stock }}</div>
        </el-form-item>
        <el-form-item label="类型">
          <div>
            <span v-if="info.type == 2">路线</span>
            <span v-else>套餐</span>
          </div>
        </el-form-item>
        <el-form-item label="审核状态">
          <div>
            <span v-if="info.inspect_status == 1">已通过</span>
            <span v-else-if="info.inspect_status == 0">待审核</span>
            <span v-else>已驳回</span>
          </div>
        </el-form-item>
        <el-form-item label="状态">
          <div>
            <span v-if="info.status == 1">正常</span>
            <span v-else style="color:red;">已下架</span>
          </div>
        </el-form-item>
      </el-form>
    </el-dialog>

    <!-- <el-dialog
      title="新增修改"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      width="1000px"
    >
      <el-form
        ref="form"
        :rules="rules[dialogStatus]"
        :model="form"
        label-position="right"
        label-width="70px"
        style="width: 800px; margin-left:50px;"
      >
        <el-form-item label="标题" prop="title" label-width="130px">
          <el-input v-model="form.title" placeholder="请输入标题" />
        </el-form-item>
        <el-form-item label="封面" prop="cover" label-width="130px">
          <uploadOne v-model="form.cover"></uploadOne>
        </el-form-item>
        <el-form-item label="轮播图" prop="images" label-width="130px">
          <uploadList v-model="form.images"></uploadList>
    </el-form-item>-->
    <!-- <el-form-item label="类型" prop="type" label-width="130px">
          <el-select v-model="form.type">
            <el-option label="套餐" :value="1"></el-option>
            <el-option label="路线" :value="2"></el-option>
          </el-select>
    </el-form-item>-->
    <!-- <el-form-item label="分类" prop="product_category" label-width="130px" :inline="true">
          <div v-for="(item,index) in form.product_category" :key="index">
            <el-row>
              <el-col :span="7">
                <div class="grid-content bg-purple">
                  <el-select
                    placeholder="国内酒店"
                    v-model="item.parent_parent_id"
                    @change="getFatherCategoryList(1,index,2)"
                  >
                    <el-option
                      v-for="item in firstList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </div>
              </el-col>
              <el-col :span="7">
                <div class="grid-content bg-purple">
                  <el-select
                    placeholder="二级类目"
                    v-if="item.parent_parent_id"
                    v-model="item.parent_id"
                    @change="getFatherCategoryList(1,index,3)"
                  >
                    <el-option
                      v-for="item in secondList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </div>
              </el-col>
              <el-col :span="7">
                <div class="grid-content bg-purple">
                  <el-select placeholder="三级类目" v-if="item.parent_id" v-model="item.id">
                    <el-option
                      v-for="item in thirdList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </div>
              </el-col>
              <el-col :span="3" style="font-size:40px;">
                <i
                  class="el-icon-circle-plus-outline"
                  @click="addClub"
                  v-if="item.id&&index == form.product_category.length-1"
                ></i>
                <i class="el-icon-remove-outline" @click="delClub(index)" v-if="index > 0"></i>
              </el-col>
            </el-row>
          </div>
        </el-form-item>
        <el-form-item label="目的地" prop="destination" label-width="130px" :inline="true">
          <el-col :span="7">
            <div class="grid-content bg-purple">
              <el-select
                placeholder="一级目的地"
                v-model="form.first_destination"
                @change="getFatherCategoryList(2,0,2)"
              >
                <el-option
                  v-for="item in firstDestinationList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </div>
          </el-col>
          <el-col :span="7">
            <div class="grid-content bg-purple">
              <el-select
                placeholder="二级目的地"
                v-if="this.form.first_destination"
                v-model="form.second_destination"
                @change="getFatherCategoryList(2,0,3)"
              >
                <el-option
                  v-for="item in secondDestinationList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </div>
          </el-col>
          <el-col :span="7">
            <div class="grid-content bg-purple">
              <el-select
                placeholder="三级目的地"
                v-if="this.form.second_destination"
                v-model="form.third_destination"
              >
                <el-option
                  v-for="item in thirdDestinationList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </div>
          </el-col>
    </el-form-item>-->
    <!-- <el-form-item label="预定方式" prop="reserve" label-width="130px" v-if="form.type==1">
          <el-select placeholder v-model="form.reserve">
            <el-option label="先付款再预定" value="1"></el-option>
            <el-option label="先预定再付款" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="库存" prop="stock" label-width="130px">
          <el-input v-model="form.stock" placeholder />
        </el-form-item>
        <el-row>
          <el-col :span="12" v-if="form.type==1">
            <div class="grid-content bg-purple">
              <el-form-item label="参考价格" prop="price" label-width="130px">
                <el-input v-model="form.price" placeholder />
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="12" v-if="form.type==2">
            <div class="grid-content bg-purple">
              <el-form-item label="成人价" prop="price" label-width="130px">
                <el-input v-model="form.price" placeholder />
              </el-form-item>
            </div>
          </el-col>

          <el-col :span="12">
            <div class="grid-content bg-purple">
              <el-form-item label="会员价" prop="vip_price" label-width="130px">
                <el-input v-model="form.vip_price" placeholder />
              </el-form-item>
            </div>
          </el-col>
        </el-row>
        <el-form-item label="儿童价(仅用于参考)" v-if="form.type==2" prop="kid_price" label-width="130px">
          <el-input v-model="form.kid_price" placeholder />
        </el-form-item>
        <el-row>
          <el-col :span="8">
            <div class="grid-content bg-purple">
              <el-form-item label="拼团价" prop="group_price" label-width="130px">
                <el-input v-model="form.group_price" placeholder />
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="grid-content bg-purple">
              <el-form-item label="成团人数" prop="group_num" label-width="100px">
                <el-input v-model="form.group_num" placeholder="单行输入" />
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="grid-content bg-purple">
              <el-form-item label="团长送双倍积分，积分1：" prop label-width="190px">1</el-form-item>
            </div>
          </el-col>
        </el-row>
        <el-form-item label="特惠小说明" prop="novel" label-width="130px">
          <el-input v-model="form.novel" placeholder="如：特惠只要￥99" />
        </el-form-item>
        <el-form-item label="费用包含" prop label-width="130px" v-if="form.type==1">
          <el-input type="textarea" :rows="2" v-model="form.description" />-->
    <!-- <el-form-item label="住宿套餐" prop label-width="100px"></el-form-item>
          <el-form-item label="套餐标题" prop="package_name" label-width="100px">
            <el-input v-model="form.package_name" placeholder />
          </el-form-item>
          <el-row v-if="form.product_package.length>0">
            <el-col :span="18">
              <div class="grid-content bg-purple" style="border:1px solid #DCDFE6;height:250px;">
                <el-form-item label="标题" prop="title" label-width="100px" style="margin-top: 10px;">
                  <el-col :span="13">
                    <el-input v-model="form.product_package[0].title" placeholder />
                  </el-col>
                </el-form-item>
                <el-form-item
                  label="住宿时长"
                  prop="live_time"
                  label-width="100px"
                  style="margin-top: 10px;"
                >
                  <el-col :span="3">
                    <el-input v-model="form.product_package[0].live_time" placeholder />
                  </el-col>
                  <el-col class="line" :span="3">晚</el-col>
                </el-form-item>
                <el-form-item
                  label="所在酒店"
                  prop="description"
                  label-width="100px"
                  style="margin-top: 10px;"
                >
                {{shopName}}
                 
                </el-form-item>
                <el-form-item
                  label="说明"
                  prop="introduce"
                  label-width="100px"
                  style="margin-top: 10px;"
                >
                  <el-col :span="13">
                    <el-input
                      type="textarea"
                      :rows="3"
                      v-model="form.product_package[0].introduce"
                    />
                  </el-col>
                </el-form-item>
              </div>
            </el-col>
          </el-row>
          <el-form-item label="其他项目" prop label-width="100px"></el-form-item>
          <div v-for="(item,index) in form.product_package" :key="index">
            <el-row v-if="index">
              <el-col :span="18">
                <div class="grid-content bg-purple" style="border:1px solid #DCDFE6;height:200px;">
                  <el-form-item
                    label="标题"
                    prop="title"
                    label-width="100px"
                    style="margin-top: 10px;"
                  >
                    <el-col :span="13">
                      <el-input v-model="item.title" placeholder />
                    </el-col>
                  </el-form-item>
                  <el-form-item
                    label="所在酒店"
                    prop="description"
                    label-width="100px"
                    style="margin-top: 10px;"
                  >
                    {{shopName}}
                  </el-form-item>
                  <el-form-item
                    label="说明"
                    prop="introduce"
                    label-width="100px"
                    style="margin-top: 10px;"
                  >
                    <el-col :span="13">
                      <el-input type="textarea" :rows="3" v-model="item.introduce" />
                    </el-col>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="grid-content bg-purple" style="font-size:80px; text-align: center;">
                  <i
                    class="el-icon-circle-plus-outline"
                    style="margin-top: 60px;"
                    v-if="index == form.product_package.length-1"
                    @click="addPackage"
                  ></i>
                  <i
                    class="el-icon-remove-outline"
                    style="margin-top: 60px;"
                    @click="delPackage(index)"
                  ></i>
                </div>
              </el-col>
            </el-row>
            <el-row v-if="form.product_package.length==1 ">
              <div class="grid-content bg-purple" style="font-size:80px; ">
                <i class="el-icon-circle-plus-outline" @click="addPackage"></i>
              </div>
            </el-row>
          </div>
        </el-form-item>
        <el-form-item label="费用包含" prop="price_include" label-width="130px" v-if="form.type==2">
          <el-input type="textarea" :rows="2" v-model="form.price_include" />
        </el-form-item>
        <el-form-item label="费用不含" prop="price_not_include" label-width="130px" v-if="form.type==2">
          <el-input type="textarea" :rows="2" v-model="form.price_not_include" />
        </el-form-item>
        <el-form-item label="打包推荐" prop="product_recommend" label-width="130px">
          <el-row>
            <div
              class="grid-content bg-purple"
              style="font-size:80px; "
              v-if="form.product_recommend.length==0"
            >
              <i class="el-icon-circle-plus-outline" @click="addRecommend"></i>
            </div>
          </el-row>
          <div v-for="(item,index) in form.product_recommend" :key="index">
            <el-row>
              <el-col :span="18">
                <div class="grid-content bg-purple" style="border:1px solid #DCDFE6;height:250px;">
                  <el-col :span="12">
                    <div class="grid-content bg-purple">
                      <el-form-item
                        label="价格"
                        prop="price"
                        label-width="50px"
                        style="margin-top: 10px;"
                      >
                        <el-input v-model="item.price" placeholder />
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :span="12">
                    <div class="grid-content bg-purple">
                      <el-form-item
                        label="原价"
                        prop="origin_price"
                        label-width="50px"
                        style="margin-top: 10px;"
                      >
                        <el-input v-model="item.origin_price" placeholder />
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-form-item
                    label="标题"
                    prop="title"
                    label-width="60px"
                    style="margin-top: 60px;"
                  >
                    <el-input v-model="item.title" placeholder />
                  </el-form-item>
                  <el-form-item
                    label="所在酒店"
                    prop="description"
                    label-width="100px"
                    style="margin-top: 10px;"
                    v-if="form.type==1"
                  >
                     {{shopName}}
                  </el-form-item>
                  <el-form-item
                    label="说明"
                    prop="introduce"
                    label-width="60px"
                    style="margin-top: 10px;"
                  >
                    <el-input type="textarea" :rows="3" v-model="item.introduce" />
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="grid-content bg-purple" style="font-size:80px; text-align: center;">
                  <i
                    class="el-icon-circle-plus-outline"
                    style="margin-top: 60px;"
                    v-if="index == form.product_recommend.length-1"
                    @click="addRecommend"
                  ></i>
                  <i
                    class="el-icon-remove-outline"
                    style="margin-top: 60px;"
                    @click="delRecommend(index)"
                  ></i>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-form-item>
        <el-form-item label="产品详情" prop="description" label-width="130px">
          <tinymce :height="400" v-model="form.description" v-if="dialogFormVisible" />
        </el-form-item>
        <el-form-item label="购买须知" prop label-width="130px">
          <el-form-item label="使用说明" prop="instructions" label-width="70px">
            <el-input type="textarea" :rows="2" v-model="form.instructions" />
          </el-form-item>
          <el-form-item
            label="退改说明"
            prop="return_modify"
            label-width="70px"
            style="margin-top: 10px;"
          >
            <el-input type="textarea" :rows="2" v-model="form.return_modify" />
          </el-form-item>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">返回</el-button>
        <el-button type="primary" @click="saveData" :loading="btnLoading">提交</el-button>
      </div>
    </el-dialog>-->

    <el-dialog
      title="推荐"
      :visible.sync="dialogFormVisible1"
      :close-on-click-modal="false"
      width="430px"
    >
      <el-form
        ref="recommend"
        :model="recommend"
        label-position="left"
        label-width="70px"
        style="width: 400px; margin-left:50px;"
      >
        <el-checkbox-group v-model="checkList" size="small">
          <el-checkbox
            label="新品&推荐"
            :value="1"
            style="display:block;"
            v-model="checkList.new_product"
          ></el-checkbox>
          <el-checkbox
            label="特价套餐"
            :value="1"
            style="display:block;"
            v-model="checkList.special_offer"
          ></el-checkbox>
        </el-checkbox-group>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible1 = false">返回</el-button>
        <el-button type="primary" @click="saveRecommend" :loading="btnLoading">提交</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="权重"
      :visible.sync="dialogWeightFormVisible"
      :close-on-click-modal="false"
      width="430px"
    >
      <el-form
        ref="weight"
        :model="weight"
        label-position="left"
        label-width="50px"
        style="width: 300px; margin-left:6px;"
      >
        <el-form-item label="权重" prop="weight" label-width="50px">
          <el-input v-model="weight.weight" placeholder="请输入权重" value="weight.weight" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogWeightFormVisible = false">返回</el-button>
        <el-button type="primary" @click="saveWeight" :loading="btnLoading">提交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import request from "@/utils/request";
import uploadList from "@/components/UploadList";
import uploadOne from "@/components/UploadOne";
import Tinymce from "@/components/Tinymce";
import { getInfo } from "@/api/login";
import { getToken } from "@/utils/auth";

export default {
  components: { Tinymce, uploadOne, uploadList },
  filters: {
    statusFilter(status) {
      const statusMap = {
        published: "success",
        draft: "gray",
        deleted: "danger"
      };
      return statusMap[status];
    }
  },
  data() {
    return {
      shop_id: null,
      shopName: null,
      list: null,
      info: null,
      total: null,
      shop: {
        id: null,
        name: null
      },
      weight: {
        id: null,
        weight: null
      },
      listLoading: true,
      btnLoading: false,
      checkList: [],
      listQuery: {
        page: 1,
        limit: 10,
        keyword: null,
        type: null,
        inspect_status: null
      },
      recommend: {
        id: null,
        new_product: null,
        special_offer: null
      },
      formInline: {
        user: "",
        region: "正常"
      },

      dialogFormVisible: false,
      dialogFormVisible1: false,
      dialogWeightFormVisible: false,
      showInfo: false,
      dialogStatus: "",
      textMap: {
        update: "编辑",
        create: "新增"
      },
      dialogPvVisible: false,
      pvData: [],
      firstList: [],
      secondList: [],
      thirdList: [],
      firstDestinationList: [],
      secondDestinationList: [],
      thirdDestinationList: [],
      shopList: [],
      form: {
        id: "",
        shop_id: "",
        title: "",
        cover: "",
        images: [],
        price: "",
        vip_price: "",
        kid_price: "",
        reserve: "",
        group_price: "",
        group_num: "",
        first_destination: "",
        second_destination: "",
        third_destination: "",
        sell: "0",
        novel: "",
        price_include: "",
        price_not_include: "",
        stock: "",
        package_name: "",
        description: "",
        instructions: "",
        return_modify: "",
        type: 1,
        inspect_status: "1",
        status: "1",
        special_offer: "1",
        new_product: "1",
        weight: "1",
        expired: "2020-12-12",
        product_package: [
          {
            id: "",
            product_id: "",
            shop_id: "",
            title: "",
            live_time: "",
            introduce: ""
          }
        ],
        product_recommend: [
          // {
          // id: "",
          // product_id: "",
          // title: "",
          // price: "",
          // origin_price: "",
          // shop_id: "",
          // introduce: ""
          // }
        ]
      },
      rules: {
        create: {
          username: [
            { required: true, message: "用户名不能为空", trigger: "change" }
          ],
          password: [
            { required: true, message: "密码不能为空", trigger: "change" }
          ]
        },
        update: {
          username: [
            { required: true, message: "用户名不能为空", trigger: "change" }
          ]
        }
      },
      //角色复选框
      checkAllRoles: false,
      isIndeterminateRoles: false,
      allRoles: [],
      //权限复选框
      checkAllPermissions: false,
      isIndeterminatePermissions: false,
      allPermissions: [],
      //按钮提交loading
      btnLoading: false
    };
  },
  created() {
    this.getList();
    // getInfo(getToken()).then(response => {
    //   this.shopName = response.data.user.name;
    //   this.shop_id = response.data.user.id;
    // });
  },
  methods: {
    getList() {
      this.listLoading = true;
      request({
        url: "/api/shop/product/index",
        method: "get",
        params: this.listQuery
      }).then(response => {
        this.list = response.data.data;
        this.total = response.data.total;
        this.listLoading = false;
      });
    },
    handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    resetForm() {
      (this.form = {
        id: "",
        shop_id: this.shop_id,
        title: "",
        cover: "",
        images: [],
        price: "",
        vip_price: "",
        kid_price: "",
        reserve: "",
        group_price: "",
        group_num: "",
        first_destination: "24",
        second_destination: "25",
        third_destination: "26",
        sell: "0",
        novel: "",
        price_include: "",
        price_not_include: "",
        stock: "",
        package_name: "",
        description: "",
        instructions: "",
        return_modify: "",
        type: 1,
        inspect_status: "",
        status: "1",
        special_offer: "1",
        new_product: "1",
        weight: "1",
        expired: "2020-12-12",
        product_category: [
          {
            id: "6",
            parent_id: "5",
            parent_parent_id: "4",

            pivot: {
              product_id: "",
              product_category_id: ""
            }
          }
        ],
        product_package: [
          {
            id: "",
            product_id: "",
            shop_id: this.shop_id,
            title: "",
            live_time: "",
            introduce: ""
          }
        ],
        product_recommend: [
          // {
          //   id: "",
          //   product_id: "",
          //   title: "",
          //   price: "",
          //   origin_price: "",
          //   shop_id: "",
          //   introduce: ""
          // }
        ]
      }),
        (this.btnLoading = false);
      this.checkAllRoles = false;
      this.isIndeterminateRoles = false;
      this.checkAllPermissions = false;
      this.isIndeterminatePermissions = false;
    },

    handleCreate() {
      this.$router.push("/product/store");
    },
    handleUpdate(id) {
      this.$router.push("/product/store?id=" + id);
    },
    getShopList() {
      request({
        url: "/api/shop/shop",
        method: "get",
        params: ""
      }).then(response => {
        this.shopList = response.data.data;
      });
    },
    handleShowInfo(row) {
      this.info = row;
      this.showInfo = true;
    },
    recommendUpdate(id, new_product, special_offer) {
      this.checkList = [];
      if (new_product == 1) {
        this.checkList.push("新品&推荐");
      }
      if (special_offer == 1) {
        this.checkList.push("特价套餐");
      }
      this.dialogStatus = "recommend";
      this.dialogFormVisible1 = true;
      this.recommend.id = id;
      this.$nextTick(() => {
        this.$refs["recommend"].clearValidate();
      });
    },
    saveRecommend() {
      if (this.checkList.indexOf("新品&推荐") != -1) {
        this.recommend.new_product = 1;
      } else {
        this.recommend.new_product = 0;
      }
      if (this.checkList.indexOf("特价套餐") != -1) {
        this.recommend.special_offer = 1;
      } else {
        this.recommend.special_offer = 0;
      }

      this.$refs["recommend"].validate(valid => {
        if (valid) {
          this.btnLoading = true;
          request({
            url: "/api/shop/product/recommend",
            method: "post",
            data: this.recommend
          })
            .then(response => {
              this.btnLoading = false;
              this.dialogFormVisible1 = false;
              this.$notify({
                title: "成功",
                message: "保存成功",
                type: "success",
                duration: 2000
              });
              this.getList();
            })
            .catch(err => {
              this.btnLoading = false;
            });
        }
      });
    },
    weightUpdate(id, weight) {
      (this.weight = {
        id: null,
        weight: null
      }),
        (this.btnLoading = false);
      this.weight.id = id;
      this.weight.weight = weight;
      console.log(this.weight);

      this.dialogWeightFormVisible = true;
      this.$nextTick(() => {
        this.$refs["weight"].clearValidate();
      });
    },
    saveWeight() {
      this.$refs["weight"].validate(valid => {
        if (valid) {
          this.btnLoading = true;
          request({
            url: "/api/shop/product/setWeight",
            method: "post",
            data: this.weight
          })
            .then(response => {
              this.btnLoading = false;
              this.dialogWeightFormVisible = false;
              this.$notify({
                title: "成功",
                message: "保存成功",
                type: "success",
                duration: 2000
              });
              this.getList();
            })
            .catch(err => {
              this.btnLoading = false;
            });
        }
      });
    },
    saveData() {
      if (this.form.type == 1) {
        this.form.shop_id = this.form.product_package[0].shop_id;
      } else {
        this.form.shop_id = 0;
        this.form.reserve = 0;
        this.form.package_name = "package_name";
        this.form.product_package = [];
      }

      this.form.kid_price ? this.form.kid_price : (this.form.kid_price = 15);
      console.log(this.form);

      this.$refs["form"].validate(valid => {
        if (valid) {
          this.btnLoading = true;
          request({
            url: "/api/shop/product/save",
            method: "post",
            data: this.form
          })
            .then(response => {
              this.btnLoading = false;
              this.dialogFormVisible = false;
              this.$notify({
                title: "成功",
                message: "保存成功",
                type: "success",
                duration: 2000
              });
              this.getList();
            })
            .catch(err => {
              this.btnLoading = false;
            });
        }
      });
    },
    handleCheckAllRolesChange(val) {
      let checkedRoles = [];
      if (val) {
        for (let i = 0; i < this.allRoles.length; i++) {
          checkedRoles.push(this.allRoles[i].id);
        }
      }
      this.form.roles = checkedRoles;
      this.isIndeterminateRoles = false;
    },
    handleCheckedRolesChange(value) {
      let checkedCount = value.length;
      this.checkAllRoles = checkedCount === this.allRoles.length;
      this.isIndeterminateRoles =
        checkedCount > 0 && checkedCount < this.allRoles.length;
    },
    handleCheckAllPermissionsChange(val) {
      let checkedPermissions = [];
      if (val) {
        for (let i = 0; i < this.allPermissions.length; i++) {
          checkedPermissions.push(this.allPermissions[i].id);
        }
      }
      this.form.permissions = checkedPermissions;
      this.isIndeterminatePermissions = false;
    },
    handleCheckedPermissionsChange(value) {
      let checkedCount = value.length;
      this.checkAllPermissions = checkedCount === this.allPermissions.length;
      this.isIndeterminatePermissions =
        checkedCount > 0 && checkedCount < this.allPermissions.length;
    },
    onSubmit() {
      this.listQuery.page = 1;
      this.list = [];
      this.getList();
      console.log(this.list);
    },
    addClub() {
      let obj = {
        id: "",
        parent_id: "",
        parent_parent_id: "",

        pivot: {
          product_id: "",
          product_category_id: ""
        }
      };
      this.form.product_category.push(obj);
    },
    delClub(idx) {
      this.form.product_category.splice(idx, 1);
    },
    addPackage() {
      let obj = {
        id: "",
        product_id: "",
        shop_id: "",
        title: "",
        live_time: "0",
        introduce: ""
      };
      this.form.product_package.push(obj);
    },
    delPackage(idx) {
      this.form.product_package.splice(idx, 1);
    },
    addRecommend() {
      let obj = {
        id: "",
        product_id: "",
        title: "",
        price: "",
        origin_price: "",
        shop_id: "",
        introduce: ""
      };
      this.form.product_recommend.push(obj);
    },
    delRecommend(idx) {
      this.form.product_recommend.splice(idx, 1);
    },
    getFatherCategoryList(type, index, level) {
      var parent_id;
      if (level == 2) {
        if (type == 1) {
          this.form.product_category[index].parent_id = "";
          this.form.product_category[index].id = "";
          parent_id = this.form.product_category[index].parent_parent_id;
        } else {
          this.form.second_destination = "";
          this.form.third_destination = "";
          parent_id = this.form.first_destination;
        }
      } else if (level == 3) {
        type == 1
          ? (parent_id = this.form.product_category[index].parent_id)
          : (parent_id = this.form.second_destination);
      }
      if (level != 1) {
        request({
          url: "/api/shop/productCategory",
          method: "get",
          params: {
            level: level,
            page: 1,
            limit: 9999,
            type: type,
            parent_id: parent_id
          }
        }).then(response => {
          if (level == 2) {
            type == 1
              ? (this.secondList = response.data.data)
              : (this.secondDestinationList = response.data.data);
          } else if (level == 3) {
            type == 1
              ? (this.thirdList = response.data.data)
              : (this.thirdDestinationList = response.data.data);
          }
        });
      } else {
        request({
          url: "/api/shop/productCategory",
          method: "get",
          params: { level: level, page: 1, limit: 9999, type: type }
        }).then(response => {
          type == 1
            ? (this.firstList = response.data.data)
            : (this.firstDestinationList = response.data.data);
        });
      }
      // if (!type) {
      //   this.form.parent_id = "";
      // }
      // if (this.first_id) {
      //   request({
      //     url: "/api/backend/productCategory",
      //     method: "get",
      //     params: { parent_id: this.first_id, page: 1, limit: 9999, type: 2 }
      //   }).then(response => {
      //     this.secondList = response.data.data;
      //   });
      //   return;
      // }
      // this.first_id = "";
      // this.form.parent_id = "";
      // request({
      //   url: "/api/backend/productCategory",
      //   method: "get",
      //   params: { level: 1, page: 1, limit: 9999, type: 2 }
      // }).then(response => {
      //   this.fatherList = response.data.data;
      // });
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.user-avatar {
  width: 40px;
  height: 40px;
  border-radius: 6px;
}
</style>




